// ### Imports
// * Import lib
import React, { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, useTheme } from "@mui/material";
import CustomTextField from "../../kit/TextField";
import Typography from "../../kit/Typography";

// * Import Kits
import Button from "../../kit/Button";
import { useStyles } from "../../theme/style";

// # Component
const DescModal = ({
  type = "",
  open,
  handleClose,
  handleDone,
  keyField,
  selectedValue,
  functionsListExceptOthers,
  jobRoleListNameExceptOthers,
}) => {
  const theme = useTheme();
  const [value, setValue] = useState("");
  const handleInputChange = (event) => setValue(event.target.value);
  const classes = useStyles();

  const updateSelections = () => {
    if (
      (type === "job_role" &&
        !jobRoleListNameExceptOthers.includes(selectedValue)) ||
      (type === "function" &&
        !functionsListExceptOthers.includes(selectedValue))
    ) {
      setValue(selectedValue);
    } else {
      setValue("");
    }
  };

  // initialize value
  useEffect(() => {
    updateSelections();
  }, [selectedValue]);

  const handleSubmit = () => {
    updateSelections();
    handleDone(keyField, value);
  };

  const isDisabled = () => {
    if (type === "job_role") {
      return !Boolean(value);
    } else {
      return value?.length ? false : true;
    }
  };

  // # JSX
  return (
    <Dialog
      open={open}
      onClose={() => {
        updateSelections();
        handleClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ "& .MuiDialog-paper": { backgroundImage: "none" } }}
    >
      <div
        style={{
          minWidth: theme.size[500],
          maxWidth: theme.size[600],
          backgroundColor: theme.palette.primary.backgroundColor,
          padding: "0px 0px 15px",
        }}
      >
        <DialogContent>
          <Typography
            sx={{
              fontWeight: theme.fontWeight[500],
              fontSize: theme.size[14],
              marginBottom: theme.size[15],
              color: theme.palette.secondary.main,
            }}
          >
            Kindly provide the
            {type === "job_role" ? " job role" : " function"}
          </Typography>
          <CustomTextField
            placeholder={`Enter ${
              type === "job_role" ? "job role" : "function"
            }`}
            size="small"
            value={value}
            onChange={handleInputChange}
            sx={{
              width: "100%",
              borderRadius: theme.size[4],
              marginBottom: theme.size[10],
            }}
          />
        </DialogContent>
        <Box
          display="flex"
          justifyContent="flex-end"
          pl={2}
          pr={theme.size[23]}
          pb={1}
          gap={2}
        >
          <Button
            disableRipple
            onClick={() => {
              updateSelections();
              handleClose();
            }}
            className={classes.outlinedButtonSmall}
          >
            Cancel
          </Button>
          <Button
            disableRipple
            onClick={handleSubmit}
            className={classes.filledButtonSmall}
            disabled={isDisabled()}
          >
            Done
          </Button>
        </Box>
      </div>
    </Dialog>
  );
};

// # Exports
export default DescModal;
